import { isFileRejection } from "./types.js";
const createNoFileError = () => new Error("no-file");
const LABEL_PREFIX = "upload.error";
const labelMapping = {
  "file-invalid-type": `${LABEL_PREFIX}.fileInvalidType`,
  "file-too-large": `${LABEL_PREFIX}.fileTooLarge`,
  "file-too-small": `${LABEL_PREFIX}.fileTooSmall`,
  "too-many-files": `${LABEL_PREFIX}.tooManyFiles`,
  "no-file": `${LABEL_PREFIX}.noFile`,
  unknown: `${LABEL_PREFIX}.unknown`
};
const getUploadErrorLabel = (currentError) => (isFileRejection(currentError) ? labelMapping[currentError.errors[0]?.code ?? ""] : labelMapping[currentError.message]) || labelMapping.unknown;
export {
  createNoFileError,
  getUploadErrorLabel
};
//# sourceMappingURL=utils.js.map
